export enum IdentifierType {
    COST_CENTER = 1,        // Centro de Costo
    TYPE_TASK = 2,          // Tipo de Tarea
}